import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getEmployeeAbsencesService = async (
  page: number,
  take: number,
  param?: string,
  status: number = 1
) => {
  try {
    const query = param
      ? `search/${param}?page=${page}&take=${take}&status=${status}`
      : `?page=${page}&take=${take}&status=${status}`;
    const url = param ? `/v1/employee-absences/${query}` : `/v1/employee-absences${query}`;
    return await http.get<any>(url);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getEmployeeAbsencesService ', error);
  }
};

export const saveEmployeeAbsenceService = async (
  data: object,
  page: number,
  take: number,
  param?: string,
  status: number = 1
) => {
  try {
    const query = param
      ? `?page=${page}&take=${take}&status=${status}&search=${param}`
      : `?page=${page}&take=${take}&status=${status}`;
    return await http.post<any>(`/v1/employee-absences${query}`, data, () => {});
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('saveEmployeeAbsenceService ', error);
  }
};

export const updateEmployeeAbsenceService = async (
  id: string,
  data: object,
  page: number,
  take: number,
  param?: string,
  status: number = 1
) => {
  try {
    const query = param
      ? `?page=${page}&take=${take}&status=${status}&search=${param}`
      : `?page=${page}&take=${take}&status=${status}`;
    return await http.put<any>(`/v1/employee-absences/${id}${query}`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('updateEmployeeAbsenceService ', error);
  }
};

export const deleteEmployeeAbsenceService = async (
  id: string,
  value: string,
  page: number,
  take: number,
  param?: string,
  status: number = 1
) => {
  try {
    const query = param
      ? `?page=${page}&take=${take}&status=${status}&search=${param}`
      : `?page=${page}&take=${take}&status=${status}`;
    return await http.deleteTable<any>(`/v1/employee-absences/${id}${query}`, { param: value });
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('deleteEmployeeAbsenceService ', error);
  }
};

export const restoreEmployeeAbsenceService = async (
  id: string,
  value: string,
  page: number,
  take: number,
  param?: string,
  status: number = 0
) => {
  try {
    const query = param
      ? `?page=${page}&take=${take}&status=${status}&search=${param}`
      : `?page=${page}&take=${take}&status=${status}`;
    return await http.patchTable<any>(`/v1/employee-absences/${id}/restore${query}`, {
      param: value,
    });
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('restoreEmployeeAbsenceService ', error);
  }
};
